import React from "react";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "3 Second Automatic Signing Packets";

const AutomaticSigningPackets = () => (
  <div className="bg-gray-100">
    <HeroSection title={title} className="flex-col-reverse md:flex-row">
      <HeroSection.Content className="w-full md:text-left md:w-3/5">
        <HeroSection.Header className="md:items-start md:justify-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          Enerflo’s proprietary doc engine, Docflo, automatically detects the anatomy of your deal to inform which
          documents are required for each specific deal. Docflo takes into account geography, language preference,
          system details, utility, rebates and more to ensure your sales reps get the right signatures the first time,
          limiting change orders and improving upstream data. Even with the complexity, it’s blazing fast -- typically
          generating complex signing packets in 3 seconds or less.
        </HeroSection.Description>
      </HeroSection.Content>

      <figure className="flex-grow w-full xs:w-2/3 md:w-2/5 pr-4">
        {/* Need to use basic img element instead of next/image so svg animation runs properly on safari */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="w-full h-full"
          src="/images/enerflo-solar-platform-automatic-signing-packets.svg"
          alt="Enerflo Solar Platform Docflo: 3 Second Automatic Signing Packets."
        />
      </figure>
    </HeroSection>
  </div>
);

export default AutomaticSigningPackets;
